export default {
  DASHBOARD: '/cp',
  MESSAGE: '/cp/message',
  FILTERS: '/cp/filters',
  SUBSCRIBERS: '/cp/subscribers',
  MISC_OPTIONS: '/cp/miscoptions',
  FEEDS: '/cp/feeds',
  SERVER_SETTINGS: '/cp/settings',
  DEBUGGER: '/cp/debugger',
  SUPPORT: '/support',
  FEED_BROWSER: '/feed-browser',
  FAQ: '/faq',
  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  TERMS: '/terms'
}
